/**
 * Institution display helpers.
 */

/** Connector words that stay lowercase in an acronym (so "The Bank of X" → "TBoX"). */
const SMALL_WORDS = new Set(['of', 'the', 'and', 'a', '&']);

/**
 * Short acronym for an institution name, used for narrow table column headers.
 * e.g. "The Bank of Fayette County" → "TBoFC", "Decatur County Bank" → "DCB".
 * Falls back to "Subject" when no name is configured.
 */
export function abbreviateInstitution(name?: string | null): string {
  if (!name || !name.trim()) return 'Subject';
  const acronym = name
    .trim()
    .split(/\s+/)
    .map((w) => {
      const c = w[0] ?? '';
      return SMALL_WORDS.has(w.toLowerCase()) ? c.toLowerCase() : c.toUpperCase();
    })
    .join('');
  return acronym.slice(0, 6) || 'Subject';
}
